export default {
	urlApis(state){ return state.urlApis; },
	langRoofCal(state){ return state.langRoofCal; },
	accessApp(state){ return state.access; },
	get_asideStorage(state){ return state.asideStorage;},		    
	gettypeStep(state){ return state.typeStep;},		    
}
